import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { theme } from '../../../config/theme';
import { getFormattedDate } from '../../../helper';
import moment from 'moment';
import { HotelInfo } from './HotelTabHelpers/HotelInfo';
import { FareRules } from './FareRules';

interface ITravelDetails {
  data: any;
}
export default function HotelDetail(props: ITravelDetails) {
  const { data } = props;
const getRoomSummary = (rooms: any) => {
    const summary:any = {};
  
    rooms?.forEach((room: any) => {
      const key = room.displayName;
      let mealType = room?.mealText
      let cancellationPolicy = room?.formattedCancellationPolicy;
      if (summary[key]) {
        summary[key].count += 1;
        summary[key].mealType = mealType;
        summary[key].cancellationPolicy = cancellationPolicy;
      } else {
        summary[key] = {
          displayName: key,
          count: 1,
          mealType: mealType,
          cancellationPolicy: cancellationPolicy,
        };
      }
    });
    return summary;
  };
  const roomSummary = getRoomSummary(data?.rooms);
  const summarizedRooms = Object?.values(roomSummary)
  return (
    <Box display='flex' flexDirection='column' gap='20px'>
      <HotelInfo hotelInfo={data?.hotelDetails} roomInfo={summarizedRooms}/>
      {data?.bookingStatus !== 'ITINERARY' && (
        <FareRules data={data} roomInfo={summarizedRooms}/>
      )}
    </Box>
  );
}
